import { Bid, User } from '../types/models';
import { getActiveBids } from './getActiveBids';

export const getUserLastBid = (bids: Bid[], user: User): Bid => {
  if (bids?.length === 0 || !user?.id) {
    return null;
  }

  const activeBids = getActiveBids(bids);

  return activeBids.find((bid) => bid.user_id === user.id);
};
